export const skeletonStyles = ({ variant }) => ({
  background: 'rgba(244, 244, 244, 1)',
  border: '1px solid rgba(229, 229, 229, 1)',
  boxSizing: 'border-box',
  maxWidth: '200px',
  ...(variant !== 'text' ? { height: '13px', width: '70%' } : {}),
  ...(variant === 'rectangular' ? { borderRadius: '4px' } : {}),
});
